import formatPrice from '@js/utilities/formatPrice';

const getEstimatedValue = ({ goldPrice, itemsWeight, itemsFineness }) => {
    const ounce = 31.1;
    const customerEarningPercent = 10;
    const finenessStandard = Number(999.9);
    const price1gram999 = goldPrice / ounce || 0;
    const price1gramCustomerProbe = (price1gram999 / finenessStandard) * itemsFineness;

    return (price1gramCustomerProbe * ((100 - customerEarningPercent) / 100) * itemsWeight).toFixed(
        0
    );
};

const goldBuyingCalculatorHandler = ({ calculatorElement, goldPrice }) => {
    const calculatorFinenessElement = calculatorElement.querySelector(
        '.js-gold-buying-calculator-fineness'
    );

    const calculatorWeightElement = calculatorElement.querySelector(
        '.js-gold-buying-calculator-weight'
    );

    const elementsHoldingEstimatedValue = calculatorElement.querySelectorAll(
        '.js-gold-buying-estimated-value'
    );

    const finenessMap = {
        dk: 333,
    };

    let itemsFineness =
        finenessMap[calculatorFinenessElement.value] || Number(calculatorFinenessElement.value);
    let itemsWeight = Number(calculatorWeightElement.value);

    const updateEstimatedValue = () => {
        const estimatedValue = getEstimatedValue({
            goldPrice,
            itemsWeight,
            itemsFineness,
        });

        elementsHoldingEstimatedValue.forEach((element) => {
            element.textContent = formatPrice(estimatedValue);
            element.value = estimatedValue;
        });
    };

    calculatorFinenessElement.addEventListener('input', () => {
        itemsFineness =
            finenessMap[calculatorFinenessElement.value] || Number(calculatorFinenessElement.value);
    });

    calculatorWeightElement.addEventListener('input', () => {
        itemsWeight = Number(calculatorWeightElement.value);
    });

    [calculatorFinenessElement, calculatorWeightElement].forEach((el) => {
        el.addEventListener('input', () => {
            updateEstimatedValue();
        });
    });

    updateEstimatedValue();
};

export const goldBuyingCalculator = async () => {
    const calculatorElements = [...document.querySelectorAll('.js-gold-buying-calculator')].filter(
        (el) => !el.dataset.goldBuyingCalculatorInitialized
    );

    if (calculatorElements.length < 1) {
        return;
    }

    const response = await fetch('/api/gold-buying/rate');
    const goldPrice = await response.json();

    console.log('gold price', goldPrice.pricePerOz);

    calculatorElements.forEach((calculatorElement) => {
        goldBuyingCalculatorHandler({
            calculatorElement,
            goldPrice: goldPrice.pricePerOz,
        });

        calculatorElement.dataset.goldBuyingCalculatorInitialized = true;
    });
};
